import Phaser from "phaser";
import { listSaves } from "../save/saveStore";

/**
 * タイトル画面。「始める」「続きから」「設定」など。
 */
export class TitleScene extends Phaser.Scene {
  private gameId = "sample-adv";

  constructor() {
    super("TitleScene");
  }

  init(data: { gameId?: string }) {
    if (data?.gameId) this.gameId = data.gameId;
  }

  create(): void {
    const w = this.scale.width;
    const h = this.scale.height;

    // タイトル背景
    this.add.rectangle(w / 2, h / 2, w, h, 0x080820);

    // タイトル装飾
    this.add
      .text(w / 2, h * 0.28, "Pix Studio Online", {
        fontFamily: "system-ui, sans-serif",
        fontSize: "56px",
        color: "#ffffff",
        fontStyle: "bold",
      })
      .setOrigin(0.5);
    this.add
      .text(w / 2, h * 0.28 + 56, "サンプル ADV — Phase 1 完成版", {
        fontFamily: "system-ui, sans-serif",
        fontSize: "20px",
        color: "#7799bb",
      })
      .setOrigin(0.5);

    const hasSaves = listSaves(this.gameId).length > 0;

    const items: Array<{ label: string; onClick: () => void; enabled: boolean }> = [
      {
        label: "▶ 始める",
        onClick: () => this.startNewGame(),
        enabled: true,
      },
      {
        label: "▶ 続きから",
        onClick: () => this.continueGame(),
        enabled: hasSaves,
      },
    ];

    const startY = h * 0.55;
    items.forEach((item, i) => {
      const y = startY + i * 70;
      const bg = this.add
        .rectangle(w / 2, y, 380, 56, item.enabled ? 0x224466 : 0x222230, 0.92)
        .setStrokeStyle(2, item.enabled ? 0x66aaff : 0x444466)
        .setInteractive({ useHandCursor: item.enabled });
      const lbl = this.add
        .text(w / 2, y, item.label, {
          fontFamily: "system-ui, sans-serif",
          fontSize: "24px",
          color: item.enabled ? "#ffffff" : "#666677",
        })
        .setOrigin(0.5);
      if (item.enabled) {
        bg.on("pointerover", () => bg.setFillStyle(0x336699, 1.0));
        bg.on("pointerout", () => bg.setFillStyle(0x224466, 0.92));
        bg.on("pointerdown", () => item.onClick());
      }
    });

    this.add
      .text(w / 2, h - 30, "© Pix Studio Online — Phase 1", {
        fontFamily: "system-ui, sans-serif",
        fontSize: "12px",
        color: "#445566",
      })
      .setOrigin(0.5);
  }

  private startNewGame(): void {
    this.scene.start("GameScene", { mode: "new" });
  }

  private continueGame(): void {
    this.scene.start("GameScene", { mode: "continue" });
  }
}
